/**
 * Constants for analytics.
 * These are not really constants as they are ultimately mutable properties
 * of an object, but they still serve their purpose of providing an alias
 * which can be used instead of a string.
 */

const { OrderDetails } = require('constants/PageTemplateType');

module.exports = (function () {
    const ASYNC_PAGE_LOAD = 'asyncPageLoad';
    const PAGE_LOAD = 'pageLoadEvent';
    const PRODUCT_PAGE_LOAD = 'productPageLoad';
    const LINK_TRACKING_EVENT = 'linkTrackingEvent';
    const SOT_LINK_TRACKING_EVENT = 'SOTLinkTracking';
    const DOUBLE_CLICK_FOOTER = 'doubleClickFooter';
    const DOUBLE_CLICK_PRODUCT_PAGE = 'doubleClickProductPage';
    const SNAPCHAT_PRODUCT_PAGE_VIEW_EVENT = 'snapchatProductPageViewEvent';
    const PINTEREST_PRODUCT_PAGE_VIEW_EVENT = 'pinterestProductPageViewEvent';
    const SNAPCHAT_QUICK_LOAD_EVENT = 'snapchatQuickLoadEvent';
    const PINTEREST_QUICK_LOAD_EVENT = 'pinterestQuickLoadEvent';
    const DOUBLE_CLICK_CATEGORY_PAGE = 'doubleClickCategoryPage';
    const CATEGORY_PAGE_LOAD = 'categoryPageLoad';
    /* Quick Look Events */
    const QUICK_LOOK_LOAD = 'quickLookLoad';

    /* Sign-In Events */
    const SIGN_IN_MODAL_LOAD = 'signInModalLoad';
    const SIGN_IN_SUCCESS = 'signInSuccess';
    const SIGN_IN_PAGE_TYPE_DETAIL = 'sign in';
    const SIGN_IN_PAGE_TYPE_GUEST_CHECKOUT_DETAIL = 'sign in-guest checkout';

    /* Registration Events */
    const REGISTER_MODAL_LOAD = 'registerModalLoad';

    /* End Quick Look Events */

    /* Used for Context */
    const ADD_TO_BASKET_MODAL = 'addToBasketModal';

    const ADD_TO_CART = 'addToCart';

    const ADD_TO_LOVES_LIST = 'addToLovesList';

    /* SIGNAL (Tag Management System)
     ** The below constants are needed because Signal does not have find and replace.
     ** These will be referenced within Signal instead of being called directly so that we can make
     ** updates here and references will still point to the actual method, value, etc. */

    //This gets populated in loadAnalytics.js, to avoid a circular reference problem.
    const GET_MOST_RECENT_EVENT = function () {};

    /* End Signal Constants */

    const PAGE_VARIANTS = {
        SWATCHES: '1',
        ONLY_FEW_LEFT: '2',
        ALTERNATE_IMAGES: '3',
        HERO_VIDEOS: '4',
        HOW_TO_USE_TAB: '5',
        INGREDIENTS_TAB: '6',
        USE_IT_WITH: '7',
        EXPLORE_VIDEOS: '8',
        EXPLORE_ARTICLES: '9',
        EXPLORE_LOOKS: '10',
        YOU_MIGHT_ALSO_LIKE: '11',
        SIMILAR_PRODUCTS: '12',
        RECENTLY_VIEWED: '13',
        STANDARD_USER: '21',
        FLASH_USER: '22',
        ROUGE_NON_FLASH_USER: '23',
        ROUGE_FLASH_USER: '24'
    };

    const CUSTOMIZABLE_SETS_VARIANTS = {
        NOT_CUSTOMIZABLE: 0,
        IS_CUSTOMIZABLE_CHOOSE_FREE_ITEM: '1',
        IS_CUSTOMIZABLE: '2'
    };

    const REFERRER_DOMAINS = [
        'google.',
        'bing.',
        'a9.',
        '*, q',
        'abacho.',
        'ah-ha.',
        'alexa.',
        'allesklar.',
        'wo,words',
        'alltheweb.',
        'q,query',
        'altavista.',
        'aol.',
        'arianna.',
        'query,b1',
        'asiaco.',
        'query,qry',
        'ask.',
        'q,ask',
        'atlas.',
        'austronaut.',
        'begriff,suche',
        'auyantepui.',
        'clave',
        'bluewin.',
        'qry,q',
        'centrum.',
        'club-internet.',
        'dino-online.',
        'dir.com.',
        'req',
        'dmoz.',
        'search',
        'dogpile.',
        'q,qkw',
        'eniro.',
        'euroseek.',
        'string,query',
        'exalead.',
        'excite.',
        'search,s,qkw',
        'findlink.',
        'key',
        'findwhat.',
        'mt',
        'fireball.',
        'freeserve.',
        'gigablast.',
        'go2net.',
        'general',
        'goeureka.',
        'key',
        'q,as_q,as_epq,as_oq',
        'googlesyndication.',
        'url',
        'greekspider.',
        'keywords',
        'hotbot.',
        'query,mt',
        'ilor.',
        'iltrovatore.',
        'index.nana.co.il.',
        'infoseek.',
        'qt,q',
        'infospace.',
        'qkw',
        'intuitsearch.',
        'iwon.',
        'ixquick.',
        'jubii.',
        'query,soegeord',
        'jyxo.',
        'kanoodle.',
        'kataweb.',
        'kvasir.',
        'live.',
        'looksmart.',
        'qt,key,querystring',
        'lycos.',
        'query,mt,q,qry',
        'mamma.',
        'metacrawler.',
        'q,general,qry',
        'msn.',
        'q,mt',
        'mywebsearch.',
        'searchfor',
        'mysearch.',
        'netex.',
        'srchkey,keyword',
        'netscape.',
        'search,searchstring,query',
        'netster.',
        'nettavisen.',
        'query,q',
        'ninemsn.',
        'nlsearch.',
        'qr',
        'nomade.',
        'mt,s',
        'northernlight.',
        'oozap.',
        'overture.',
        'ozu.',
        'passagen.',
        'quick.',
        'ftxt_query',
        'savvy.',
        'scrubtheweb.',
        'keyword,q',
        'www.search.com.',
        'searchalot.',
        'searchhippo.',
        'sensis.',
        'find',
        'seznam.',
        'w',
        'soneraplaza.',
        'qt',
        'splatsearch.',
        'searchstring',
        'sprinks.',
        'terms',
        'spray.',
        'srch.',
        'supereva.',
        'teoma.',
        'thunderstone.',
        'tiscali.ch.',
        'key',
        'tjohoo.',
        'soktext,mt,query',
        'track.',
        'truesearch.',
        'tygo.',
        'vinden.',
        'virgilio.',
        'qs',
        'vivisimo.',
        'voila.',
        'kw',
        'walla.',
        'wanadoo.',
        'fkw',
        'web.',
        'su',
        'webcrawler.',
        'qkw,search,searchtext',
        'webwatch.',
        'findindb',
        'wepa.',
        'query',
        'wisenut.',
        'xpsn.',
        'kwd',
        'ya.',
        'yahoo.',
        'p,va,vp,vo',
        'ynet.',
        'zerx.'
    ];

    // The most up-to-date event dictionary is supposed to be under
    // the following link:
    // https://jira.sephora.com/wiki/pages/viewpage.action
    // ?spaceKey=ANLYTX&title=SiteCatalyst+Variable+Mapping+and+Reports
    const Event = {
        INTERNAL_SEARCH: 'event1',
        FAILED_SEARCH: 'event2',

        EMAIL_OPT_IN: 'event6',

        REGISTRATION_WITH_BI: 'event11',
        REGISTRATION_WITHOUT_BI: 'event12',
        REGISTRATION_STEP_1: 'event14',
        REGISTRATION_SUCCESSFUL: 'event15',
        SIGN_IN_SUCCESS: 'event100',
        SIGN_IN_ATTEMPT: 'event140',
        SIGN_IN_FAILED: 'event141',
        SIGN_IN_RELOAD: 'signInReload',
        UPLOAD_PROFILE_PHOTO: 'event180',
        EDIT_ABOUT_ME_TEXT: 'event181',
        PRODUCT_VIEW: 'event24',
        PROD_VIEW: 'prodView',
        PRODUCT_COUNT: 'event23',
        PRODUCT_PAGE_VIEW: 'event200',
        PRODUCT_CLEAN_LABEL: 'event238',
        PRODUCT_PAGE_COLORIQ_ENABLED: 'event201',
        CANADA_REVENUE: 'event101',
        CANADA_DISCOUNT: 'event144',
        ENDECA_SEARCH: 'event234',
        NLP_SEARCH: 'event233',

        // TODO: Assign better names to these constants
        EVENT_4: 'event4',
        EVENT_17: 'event17',
        EVENT_27: 'event27',
        EVENT_28: 'event28',
        HARD_GOOD_PRESENT: 'event34',
        GIFT_CARD_REVENUE: 'event35',
        ATB_FROM_BASKET_LOVE_CAROUSEL: 'event36',
        EVENT_37: 'event37',
        CAPTCHA_PRESENT: 'event39',
        EVENT_46: 'event46',
        EVENT_58: 'event58',
        EVENT_59: 'event59',
        EVENT_61: 'event61',
        EVENT_71: 'event71',
        EVENT_80: 'event80',
        EVENT_81: 'event81',
        EVENT_102: 'event102',
        EVENT_103: 'event103',
        EVENT_104: 'event104',
        EVENT_105: 'event105',
        EVENT_106: 'event106',
        EVENT_107: 'event107',
        EVENT_108: 'event108',
        EVENT_109: 'event109',
        EVENT_160: 'event160',
        EVENT_161: 'event161',
        EVENT_162: 'event162',
        EVENT_214: 'event214',
        BOOK_RESERVATION_SUCCESS: 'event215',
        RSVP_EVENT_SUCCESS: 'event217',
        RESCHEDULE_SUCCESS: 'event218',
        BOOK_ADD_SPECIAL_REQUEST: 'event224',
        EVENT_219: 'event219',
        EVENT_220: 'event220',
        EVENT_221: 'event221',
        EVENT_230: 'event230',
        EVENT_239: 'event239',
        EVENT_244: 'event244',
        EVENT_247: 'event247',
        EVENT_248: 'event248',
        EVENT_257: 'event257',
        EVENT_263: 'event263',

        SC_VIEW: 'scView',
        SC_REMOVE: 'scRemove',
        SC_ADD: 'scAdd',
        SC_CHECKOUT: 'scCheckout',

        SC_GUEST_ORDER_SIGN_IN_LOAD: 'event210',
        SC_GUEST_ORDER_SIGN_IN_CLICK: 'event211',
        SC_GUEST_ORDER: 'event212',
        SC_GUEST_ORDER_REGISTERED_USER: 'event213',

        SC_CREDIT_CARD_APPLY_PAGE_LOAD: 'event182',
        SC_CREDIT_CARD_APPROVED: 'event183',
        SC_CREDIT_CARD_PENDING: 'event184',
        SC_CREDIT_CARD_ERROR: 'event185',
        SC_CREDIT_CARD_SUBMIT: 'event245',

        ADD_REVIEW_RATE_AND_REVEW: 'event148',
        ADD_REVIEW_CONFIRMATION: 'event149',

        REWARD_PRESENT: 'event120',
        ONLY_REWARD: 'event126',
        PROMOTION_APPLIED: 'event54',
        SAMPLES_PRESENT: 'event51',
        SAMPLES_REDEEMED: 'event60',
        BI_CHIP_SUBSCRIBE: 'event186',

        VIB_TIER_MIGRATION: 'event236',
        ROUGE_TIER_MIGRATION: 'event237',
        ORDER_CANCELLATION_REQUEST: 'event241',
        ORDER_CANCELLATION_SUCCESS: 'event242',
        ORDER_CANCELLATION_DECLINE: 'event243',
        AUTO_REPLENISH_ACTIVE_PRODUCTS: 'event250',
        AUTO_REPLENISH_PAUSED_PRODUCTS: 'event251',
        AUTO_REPLENISHMENT_PRODUCT_SETTING: 'event249',
        SDU_SUBSCRIPTION_CANCELED: 'event258',
        REPORT_ISSUE_MODAL: 'event259=1',
        EVENT_254: 'event254=1',
        BEAUTY_PREFERENCES_PAGE_VISITS: 'event223'
    };

    const EVENT_NAMES = {
        ADD_TO_BASKET: 'add_to_basket',
        FACEBOOK_ADD_TO_BASKET: 'facebook_add_to_basket',
        ADD_TO_LOVES: 'add_to_loves',
        ERROR: 'error',
        REMOVE_FROM_LOVES: 'remove_from_loves',
        CERTONA_IMPRESSION: 'certona_impression',
        HERO_VIDEO_CLICK: 'HERO_VIDEO_CLICK',
        PRODUCT_ZOOM_MODAL_VIDEO_CLICK: 'PRODUCT_ZOOM_MODAL_VIDEO_CLICK',
        REGISTERED_FOR_BI: 'registeredForBI',
        REMOVE_FROM_BASKET: 'RemoveFromBasket',
        CREDIT_CARD_SIGNUP: 'creditCardSignup',
        BOOKED_RESERVATION: 'bookedReservation',
        GA_BEGIN_CHECKOUT: 'ga_begin_checkout',
        ROPIS_ORDER: 'ropis_order',
        BOPIS_ORDER: 'bopis_order',
        SAME_DAY_ORDER: 'SameDayDelivery',
        GENERIC_ERROR_PAGE_LOAD: 'genericErrorPageLoad',
        GENERIC_ERROR_TRACKING: 'genericErrorTracking',
        PLA_SPONSORED_PRODUCT_CLICK: 'pla_sponsored_product_click',
        PLA_SPONSORED_CAROUSEL_CLICK: 'pla_sponsored_carousel_click',
        PLA_SPONSORED_PRODUCT_VIEWABLE_IMPR: 'pla_sponsored_product_viewable_impression',
        PLA_SPONSORED_CAROUSEL_VIEWABLE_IMPRESSION: 'pla_sponsored_carousel_viewable_impression',
        PLA_SPONSORED_BANNER_CLICK: 'pla_sponsored_banner_click',
        PLA_SPONSORED_BANNER_VIEWABLE_IMPR: 'pla_sponsored_banner_viewable_impression',
        SAME_DAY_DELIVERY_RADIO_BUTTON_CLICK: 'same-day delivery radio button click',
        RMN_PLA_CLICK: 'rmn-pla-click:product',
        RMN_BANNER_CLICK: 'rmn-banner-click:non-product',
        ASK_QUESTION_BODY_DETAILS: 'ask_question_body_details',
        ANSWER_QUESTION_BODY_DETAILS: 'answer_question_body_details',
        CAROUSEL_PRODUCT_CLICK: 'carousel_product_click',
        CAROUSEL_NAVIGATION_CLICK: 'carousel_navigation_click',
        AUTO_REPLENISHMENT: {
            FREQUENCY_CONFIRMED: 'auto replenish delivery frequency confirmed',
            FREQUENCY_CLOSE: 'auto replenish delivery frequency close',
            UNSUBSCRIBE: 'auto replenish unsubscribe subscription confirmation',
            MANAGE_SUBSCRIPTION_CLOSE: 'auto replenish manage subscription close',
            GET_IT_SOONER_CONFIRM: 'auto replenish get it sooner subscription confirmation',
            GET_IT_SOONER_CLOSE: 'auto replenish get it sooner subscription close',
            GET_IT_SOONER_UNAVAILABLE: 'auto replenish get it sooner subscription unavailable',
            RESUME_CLOSE: 'auto replenish resume subscription close',
            PAUSE_CLOSE: 'auto replenish pause subscription close',
            PAUSE_CONFIRMATION: 'auto replenish pause subscription confirmation'
        },
        SAME_DAY_UNLIMITED: {
            UPDATE_PAYMENT_SAVE: 'same day unlimited edit payment save',
            UPDATE_PAYMENT_CLOSE: 'same day unlimited edit payment close',
            ADD_PAYMENT_SAVE: 'same day unlimited add payment save',
            ADD_PAYMENT_CLOSE: 'same day unlimited add payment close',
            REMOVE_PAYMENT: 'same day unlimited remove payment'
        },
        BANNER: {
            BANNER_IMPRESSION: 'personalized banner viewable impression',
            PERSONALIZED_BANNER_CLICK: 'personalized banner click'
        }
    };

    const MEDIA_TYPE = {
        IMAGE: 'IMAGE',
        VIDEO: 'VIDEO'
    };

    const CONTEXT = {
        BASKET_PRODUCT: 'product',
        BASKET_SAMPLES: 'basket_samples',
        BASKET_REWARDS: 'basket_rewards',
        BASKET_LOVES: 'basket_loves',
        BASKET_PAGE: 'basket',
        CHECKOUT_PAGE: 'checkout',
        USE_IT_WITH: 'use it with',
        QUICK_LOOK: 'quicklook',
        ADD_FLASH_BASKET_BANNER: 'add flash in basket banner',
        ROUGE_ENROLL_FLASH: 'rouge_enroll_flash',
        ROUGE_REWARD_CARD_BANNER: 'rouge_reward_card_banner',
        PRODUCTPAGE: 'product',
        CONTENT_STORE: 'content_store',
        ADD_FLASH_BASKET: 'add_flash_basket',
        ADD_TO_BASKET_STICKY_BANNER: 'add_to_basket_sticky_banner',
        ORDER_CONFIRMATION: 'order-confirmation',
        REPLEN_PRODUCT: 'replen_product',
        BI_REWARDS_CAROUSEL: 'bi_rewards_carousel',
        FREQUENTLY_BOUGHT_TOGETHER: 'frequently bought together',
        CLEAN_AT_SEPHORA: 'clean at sephora',
        BEAUTY_OFFERS: 'beauty offers',
        SAME_DAY_UNLIMITED: 'same-day unlimited',
        REPLACEMENT_ORDER: 'replacement-order'
    };

    const CAMPAIGN_STRINGS = {
        ADD_TO_BASKET: 'add-to-basket',
        ENROLL_IN_FLASH: 'flash basket banner:enroll in flash',
        ADD_FLASH_IN_BASKET_BANNER: 'flash basket banner:add to basket',
        DEFAULT_CAROUSEL_PARAM: 'product',
        PDP_TOP_CERTONA_CAROUSEL_PARAM: 'product-brandtext',
        ADD_FLASH_TO_BASKET: 'flash my account:add to basket',
        RMN_PLA: 'rmn-pla',
        RMN_BANNER: 'rmn-banner'
    };

    const LinkData = {
        SSI: 'stay signed in',
        SELECT_SAMPLES: 'basket:select samples:top',
        SELECT_REWARDS: 'basket:redeem rewards:top',
        CHECKOT_BUTTON_STANDARD: 'checkout:payment:standard',
        ROPIS_CONTINUE_TO_RESERVATION: 'continue to reservation details',
        BOPIS_CONTINUE_TO_RESERVATION: 'continue to checkout',
        ROPIS_RESERVATION_COMPLETE: 'complete reservation',
        BOPIS_ORDER_COMPLETE: 'place order',
        ENROLL_IN_FLASH: 'Enroll in Flash',
        BI_PRIVATE_PROFILE: 'profile:bi-traits:private',
        BACK_TO_TOP: 'ppage:back_to_top',
        VIEW_ARTICLES: 'product_learn more_related articles_non-glossy',
        VIEW_PHOTOS: 'product_learn more_related photos',
        MODAL: 'modal',
        RECOMMENDED_ADDRESS: 'address verification:use recommended address:drop-down',
        CUSTOMER_CHAT_SESSION_STARTED: 'customer chat:start session',
        CUSTOMER_CHAT_NOW_CTA: 'proactive customer chat-chat now cta:start session',
        BRANDSLIST: 'brandslist:page:products_back_to_top',
        STORESLIST: 'storeslist:page:products_back_to_top',
        PRODUCTS_BACK_TO_TOP: 'products_back_to_top',
        VIDEO_POPUP: 'video popup',
        CCPA_COOKIE_BANNER_ACCEPT: 'ccpa cookies:accept',
        CCPA_COOKIE_BANNER_PRIVACY: 'ccpa cookies:privacy policy',
        TLP_SHOP_NOW: 'your promo:shop now',
        PFD_APPLY: 'bi:points for discount:apply in basket',
        RRC_APPLY: 'bi:rouge rewards:apply in basket',
        ADV_SHOP_NOW: 'advocacy:shop now',
        LOVES_MODAL_VIEW_ALL: 'loves modal:view all',
        VIEW_IN_BASKET_BUTTON: 'view in basket button',
        VIEW_ITEMS_AND_RESERVE: 'view items and reserve',
        VIEW_ITEMS_AND_CHECKOUT: 'view items and checkout',
        ADD_TO_BASKET_CUSTOM_SET: 'product:custom set:add all to basket',
        VIEW_ITEMS_AND_CHECKOUT_BOPIS: 'view items and checkout:bopis',
        VIEW_ITEMS_AND_CHECKOUT_SHIPPED: 'view items and checkout:shipped',
        VIEW_SHIPPING_AND_RETURNS: 'shipping and returns',
        VIEW_INFORMATION_ICON: 'information icon',
        VIEW_OTHER_STORES: 'check other stores',
        SHOW_MORE_PRODUCTS: 'show more products',
        READY_TO_CHECKOUT: 'ready to checkout',
        CUSTOMER_CHAT_DISPLAYED: 'customer chat:displayed',
        CUSTOMER_CHAT_SESSION_ENDED: 'customer chat:end session',
        CUSTOMER_CHAT_UNAVAILABLE: 'customer chat:unavailable',
        PERSONAL_RECOMMENDATION: 'personal-recommendation:click',
        SEPHORA_CHECKOUT_BUTTON: 'checkout:payment:pay with sephora credit card',
        GIFT_CARD: 'gift card',
        SHOP_PAGE: 'shop:page',
        SAME_DAY_TIME_SELECTION: 'same day delivery:time selection confirm',
        SAME_DAY_TIME_SELECTOR_CLOSE: 'same day delivery:time selection modal close',
        SAME_DAY_TIME_SELECTOR_OPEN: 'same day delivery:time selection modal open',
        BRAND_PAGE: 'brand:page',
        SEARCH_PAGE: 'search:page',
        ACCESS_POINT_LOCATION_DETAILS_CLICK: 'access points location details:click',
        ACCESS_POINT_MODAL_OPEN_CLICK: 'access points entry:click',
        AUTO_REPLENISH: 'auto replenish:subscription info modal open',
        AUTO_REPLENISH_FREQUENCY_OPEN: 'auto replenish:delivery frequency open',
        AUTO_REPLENISH_FREQUENCY_CLOSE: 'auto replenish:delivery frequency close',
        AUTO_REPLENISH_FREQUENCY_CONFIRMED: 'auto replenish:delivery frequency confirmed',
        MANAGE_SUBSCRIPTION_OPEN: 'auto replenish:manage subscription open',
        MANAGE_SUBSCRIPTION_CLOSE: 'auto replenish:manage subscription close',
        UNSUBSCRIBE_SUBSCRIPTION_OPEN: 'auto replenish:unsubscribe subscription open',
        UNSUBSCRIBE_SUBSCRIPTION_CLOSE: 'auto replenish:unsubscribe subscription close',
        PAUSE_SUBSCRIPTION_OPEN: 'auto replenish:pause subscription open',
        PAUSE_SUBSCRIPTION_CLOSE: 'auto replenish:pause subscription close',
        BOPIS_STORE_SELECTED: 'bopis store selected',
        UPDATE_PAYMENT_OPEN: 'auto replenish:update payment open',
        UPDATE_PAYMENT_CLOSE: 'auto replenish:update payment close',
        ADD_CARD_OPEN: 'auto replenish:add payment open',
        ADD_CARD_CLOSE: 'auto replenish:add payment close',
        EDIT_CARD_OPEN: 'auto replenish:edit payment open',
        EDIT_CARD_CLOSE: 'auto replenish:edit payment close',
        SAVE_CARD_EDIT: 'auto replenish:edit payment saved',
        SAVE_CARD_ADD: 'auto replenish:add payment saved',
        SAVE_CARD_UPDATE: 'auto replenish:update payment saved',
        DELETE_CARD: 'auto replenish:delete payment',
        REMOVE_CARD: 'auto replenish:remove payment',
        AUTO_REPLENISH_LOAD_MORE: 'auto replen:load more',
        SKIP_SUBSCRIPTION_OPEN: 'auto replenish:skip subscription open',
        SKIP_SUBSCRIPTION_CLOSE: 'auto replenish:skip subscription close',
        GET_IT_SOONER_OPEN: 'auto replenish:get it sooner subscription open',
        GET_IT_SOONER_CLOSE: 'auto replenish:get it sooner subscription close',
        RESUME_SUBSCRIPTION_OPEN: 'auto replenish:resume subscription open',
        RESUME_SUBSCRIPTION_CLOSE: 'auto replenish:resume subscription close',
        PHOTO_AND_BIO: 'photo and bio',
        PRIVACY_SETTINGS: 'bp privacy settings',
        COMMUNITY_PROFILE: 'cmnty profile',
        MY_PROFILE: 'my-profile',
        SDU_UPDATE_PAYMENT_OPEN: 'same-day unlimited:update payment open',
        SDU_UPDATE_PAYMENT_CLOSE: 'same-day unlimited:update payment close',
        SDU_ADD_CARD_OPEN: 'same-day unlimited:add payment open',
        SDU_ADD_CARD_CLOSE: 'same-day unlimited:add payment close',
        SDU_EDIT_CARD_OPEN: 'same-day unlimited:edit payment open',
        SDU_EDIT_CARD_CLOSE: 'same-day unlimited:edit payment close',
        SDU_REMOVE_CARD: 'same-day unlimited:remove payment',
        SDU_DELETE_CARD: 'same-day unlimited:delete payment',
        SDU_SAVE_CARD_UPDATE: 'same-day unlimited:update payment saved',
        SDU_SAVE_CARD_EDIT: 'same-day unlimited:edit payment saved',
        SDU_SAVE_CARD_ADD: 'same-day unlimited:add payment saved',
        SDU_CANCEL_SUBSCRIPTION_OPEN: 'same-day unlimited:cancel subscription open',
        SDU_CANCEL_TRIAL_OPEN: 'same-day unlimited:cancel trial open',
        BASKET_SIGN_IN: 'sign-in:text-link',
        BASKET_SIGN_IN_FREE_SHIPPING: 'sign-in:free-shipping',
        EMPTY_BASKET_SIGN_IN: 'sign-in:empty-basket',
        FREE_RETURNS: 'free returns click'
    };

    const PAGE_NAMES = {
        ACCOUNT_CREATION: 'account creation',
        ANONYMOUS: 'anonymous',
        BASKET: 'basket',
        PREBASKET: 'pre-basket',
        BENEFITS: 'benefits',
        BRANDNTHCATEGORY: 'brand-nthcategory',
        BRANDSLIST: 'brands-list',
        CATEGORYLEVEL: 'categorylevel',
        NTHCATEGORY: 'nthlevel',
        GC_SHIPPING: 'gift card shipping',
        GC_DELIVERY: 'gift card delivery',
        HOMEPAGE: 'home page',
        LISTS_MAIN: 'lists-main',
        MY_ACCOUNT: 'my-account',
        MY_BEAUTY_INSIDER: 'my beauty insider',
        RESERVE_CONFIRMATION: 'reserve-confirmation',
        ORDER_CONFIRMATION: 'order-confirmation',
        ORDER_DETAIL: 'order-detail',
        PROFILE: 'my-profile',
        PRODUCT: 'product',
        PRODUCTPAGE: 'product',
        PLACE_ORDER: 'place order',
        ROPIS_BASKET: 'reserve and pickup',
        ROPIS_CHECKOUT: 'reserve and pickup-reservation details',
        USER_PROFILE: 'user-profile',
        FAILED_SEARCH: 'results-null',
        BOOK_CLASS_LANDING: 'book a class-landing',
        BOOK_SERVICE_LANDING: 'book a service-landing',
        BOOK_EVENT_LANDING: 'book a event-landing',
        BOOK_ANNOUNCEMENT_LANDING: 'book a announcement-landing',
        BOOK_SERVICE_CONFIRMATION: 'book a service-confirmation',
        BOOK_CLASS_CONFIRMATION: 'book a class-confirmation',
        RSVP: 'book an event-rsvp',
        RESCHEDULE_CLASS_CONFIRMATION: 'reschedule class-confirmation',
        RESCHEDULE_SERVICE_CONFIRMATION: 'reschedule service-confirmation',
        WAITLISTED_CLASS_CONFIRMATION: 'book a class-waitlisted',
        CREDIT_CARD_APPLICATION_START: 'application-start',
        CREDIT_CARD_APPLICATION_APPROVED: 'application-approved',
        CREDIT_CARD_APPLICATION_PENDING: 'application-pending',
        STORE_LOCATOR: 'store locator',
        STORE_LIST: 'store list',
        SHIPPING_AND_DELIVERY: 'shipping and delivery',
        SHIPPING_ADD_ADDRESS: 'shipping-add address',
        SHIPPING_USE_RECOMMENDED_ADDRESS: 'shipping-use recommended address',
        SIGNED_IN: 'signed in',
        PRODUCT_SEARCH_RESULTS: 'results-products',
        ADV_CAMPAIGNS: 'campaigns',
        ADD_RATINGS_AND_REVIEWS: 'ratings&reviews-write',
        BOPIS_BASKET: 'buy online and pickup',
        BOPIS_CHECKOUT: 'buy online and pickup-reservation details',
        BOPIS_CONFIRMATION: 'bopis-confirmation',
        SAMEDAY_CONFIRMATION: 'sameday-confirmation',
        SHADE_FINDER_RESULTS: 'shade finder-results',
        SHADE_FINDER_MATCH_FOUND: 'shade finder-match found',
        SAME_DAY_DELIVERY: 'same day',
        SMART_CHAT: 'chat:home chat',
        FREE_RETURNS: 'free returns-information',
        UGC_MODAL: 'ugc modal',
        ACCESS_POINT_INFO_MODAL: 'accesss points-how it works',
        ACCESS_POINT_INFO_MODAL_OPEN: 'access points-select fedex location',
        ACCESS_POINT_LOCATION_DETAILS: 'access points-fedex location details',
        ACCESS_POINT_INFO_MODAL_NO_RESULTS: 'access points-no fedex locations available',
        ACCESS_POINT_INFO_MODAL_UNAVAILABLE: 'access points-selected location unavailable',
        BEAUTY_PREFERENCES: 'beauty preferences',
        MY_SEPHORA: 'mysephora',
        SAME_DAY_UNLIMITED: 'same-day unlimited'
    };

    const PAGE_TYPES = {
        HOMEPAGE: 'home page',
        BASKET: 'basket',
        CHECKOUT: 'checkout',
        USER_PROFILE: 'user profile',
        COMMUNITY: 'cmnty',
        QUICK_LOOK: 'quicklook',
        ADD_TO_BASKET_MODAL: 'add to basket modal',
        ADD_ALL_TO_BASKET: 'add all to basket',
        ADD_TO_BASKET_FOR_PICKUP_MODAL: 'add to basket for pickup modal',
        LOVES_MODAL: 'loves modal',
        COMMUNITY_PROFILE: 'cmnty profile',
        PRODUCT_FINDER: 'productfinder',
        PRODUCT: 'product',
        PRODUCTPAGE: 'product',
        REWARDS: 'rewards',
        SEARCH_TOP: 'top',
        SEARCH_NTH: 'nth',
        SEARCH_CATEGORY: 'category',
        NTHCATEGORY: 'nthlevel',
        TOPCATEGORY: 'toplevel',
        ROOTCATEGORY: 'category',
        RWD_TOPCATEGORY: 'toplevel',
        RWD_CATEGORY: 'category',
        RWD_NTHCATEGORY: 'nthlevel',
        BRAND: 'brand',
        BRANDCAT: 'brand-category',
        BRANDTOP: 'brand-toplevel',
        BRANDNTH: 'brand-nthlevel',
        SEARCH: 'search',
        OLR: 'happening at sephora',
        CONTENT_STORE: 'contentstore',
        CREDIT_CARD: 'creditcard',
        PLAY_QUIZ: 'play! by sephora',
        SIGN_IN: 'sign in',
        REGISTER: 'register',
        ERROR_PAGE: 'error page',
        VIEW_SIMILAR: 'view similar',
        REWARDS_BAZAAR_MODAL: 'modal',
        ADV_REFERRER: 'advocacy referrer',
        BOPIS: 'buy online and pickup',
        ROPIS: 'reserve and pickup',
        PRODUCT_REVIEW: 'reviews',
        VIEW_MORE_CLEAN_BEAUTY: 'view more clean beauty',
        SAME_DAY_LOCATION_SELECTOR: 'same day-select delivery location',
        FREQUENTLY_BOUGHT_TOGETHER: 'frequently bought together',
        COMPARE_SIMILAR_PRODUCTS: 'compare similar products',
        RETURNS: 'returns',
        SHIPPING: 'shipping',
        UGC_MODAL: 'modal',
        SAME_DAY_TIME_SELECTOR: 'same day-select delivery time',
        GENERIC_MODAL: 'modal',
        SEOP: 'seop',
        AUTO_REPLENISH: 'auto replenish',
        AUTO_REPLENISHMENT: 'autoreplenishment',
        SAME_DAY_UNLIMITED: 'same-day unlimited',
        ENTER_ZIP_CODE: 'enter zip code',
        TRIAL_OFFER: 'trial offer',
        TRIAL_ALREADY_ADDED: 'trial already added',
        SUBSCRIPTION_OFFER: 'subscription offer',
        SUBSCRIPTION_ALREADY_ADDED: 'subscription already added',
        TRIAL_ADDED_TO_BASKET_CONFIRMATION: 'trial added to basket confirmation',
        SUBSCRIPTION_ADDED_TO_BASKET_CONFIRMATION: 'subscription added to basket confirmation',
        REPLACEMENT_ORDER: 'replacement-order',
        ORDER_DETAIL_REPORT_ISSUE: 'report-issue'
    };

    const PRODUCT_TAGGING_PLATFORMS = {
        CHAT: 'chat',
        GALLERY: 'gallery',
        REVIEWS: 'reviews'
    };

    const COMPONENT_TITLE = {
        PRODUCTS_GRID: 'products grid',
        SKUGRID: 'skugrid',
        SEPHORA_CAROUSEL: 'sephora carousel',
        PURCHASE_LISTS: 'purchase lists',
        ALT_IMAGE_CAROUSEL: 'alt-image',
        READY_TO_CHECKOUT: 'ready to checkout',
        CHOSEN_FOR_YOU: 'Chosen For You',
        SELLING_FAST: 'Selling Fast',
        NEW_ARRIVALS: 'New Arrivals',
        VALUE_SETS: 'Value Sets'
    };

    const CAROUSEL_NAMES = {
        LOVES: 'loves',
        PURCHASES: 'purchases',
        SERVICES: 'services',
        USER_PROFILE: 'user profile',
        CC_LOVES: 'shop your favorites',
        REPLEN: 'restock past purchases',
        RECENTLY_VIEWED: 'recently viewed',
        REWARDS: 'rewards',
        FREQUENTLY_BOUGHT_TOGETHER: 'frequently bought together',
        REWARD_BAZAAR: 'reward bazaar'
    };

    const PAGE_DETAIL = {
        SHIPPING_UNVERIFIED: 'shipping-double check your address',
        SHIPPING_RECOMMENDED: 'shipping-use recommended address',
        SIGN_IN_AND_REGISTER: 'sign in and register',
        RESET_PASSWORD: 'reset password',
        REWARDS_BAZAAR: 'rewards bazaar',
        CREDIT_CARD_REWARDS: 'creditcard rewards',
        APPLY_POINTS: 'apply points',
        AFTERPAY_PAYMENT: 'afterpay',
        KLARNA_PAYMENT: 'klarna',
        FLEXIBLE_PAYMENTS: 'flexible-payments',
        RESERVATION_DETAILS: 'reservation-details',
        SHIPPING_INFORMATION: 'customer service help-shipping information',
        BCC_INFORMATION_MODAL: 'bcc information-modal',
        STORE_SELECTION: 'store selection',
        ADD_REVIEW_SELECT_SKU: 'ratings&reviews-select sku',
        ADD_REVIEW_WRITE: 'ratings&reviews-write',
        ADD_REVIEW_ABOUT: 'ratings&reviews-about you',
        ADD_REVIEW_SUBMIT: 'ratings&reviews-submit',
        SHADE_FINDER: 'shade finder',
        SHADE_FINDER_LANDING: 'shade finder-landing page',
        ESTIMATED_SHIPPING_INFORMATION: 'estimated shipping information',
        SUBSCRIPTION_INFO: 'subscription info modal',
        DELIVERY_FREQUENCY: 'delivery frequency',
        MANAGE_SUBSCRIPTION: 'manage subscription',
        UNSUBSCRIBE_SUBSCRIPTION: 'unsubscribe subscription',
        UNSUBSCRIBE_CONFIRMATION: 'unsubscribe subscription confirmation',
        PAUSE_SUBSCRIPTION: 'pause subscription',
        PAUSE_CONFIRMATION: 'pause subscription confirmation',
        UPDATE_PAYMENT: 'update payment',
        ADD_CARD: 'add payment',
        EDIT_CARD: 'edit payment',
        SKIP_SUBSCRIPTION: 'skip subscription',
        SKIP_SUBSCRIPTION_CONFIRM: 'skip subscription confirmation',
        SKIP_SUBSCRIPTION_UNAVAILABLE: 'skip subscription unavailable',
        GET_IT_SOONER: 'get it sooner subscription',
        GET_IT_SOONER_CONFIRMATION: 'get it sooner subscription confirmation',
        GET_IT_SOONER_UNAVAILABLE: 'get it sooner subscription unavailable',
        RESUME_SUBSCRIPTION: 'resume subscription',
        RESUME_SUBSCRIPTION_CONFIRM: 'resume subscription confirmation',
        SEPHORA_CC_INFO: 'sephora cc info modal',
        SAME_DAY_UNLIMITED_FAQ_PAGE: 'customer service help-same-day delivery unlimited faqs',
        SAME_DAY_UNLIMITED_FAQ_MODAL: 'same-day delivery unlimited faq modal',
        CANCEL_SUBSCRIPTION: 'cancel subscription',
        CANCEL_TRIAL: 'cancel trial',
        ZIP_CODE_UNAVAILABLE: 'zip code unavailable',
        CANCEL_SUBSCRIPTION_CONFIRMATION: 'cancel subscription confirmation',
        CANCEL_TRIAL_CONFIRMATION: 'cancel trial confirmation',
        REPORT_ISSUE_MODAL: 'select reason',
        NCR_ELEGIBLE: 'ncr eligible',
        NCR_NOT_ELEGIBLE: 'ncr not eligible'
    };

    const ACTION_INFO = {
        ADDRESS_VERIFICATION: 'address verification:use {0} address',
        ORDER_CANCELLATION: 'order cancellation',
        ADD_TO_BASKET: 'add to basket',
        SEE_DETAILS: 'see details'
    };

    const SDU_STATUS = {
        SUBSCRIBED: 'subscribed',
        UNSUBSCRIBED: 'unsubscribed',
        UNSUBSCRIBED_NOT_ELIGIBLE: 'unsubscribed-not eligible'
    };

    const SDU_SUBSCRIPTION_TYPE = {
        SUBSCRIBED: 'subscribed',
        UNSUBSCRIBED: 'trial eligible',
        UNSUBSCRIBED_NOT_ELIGIBLE: 'not trial eligible'
    };

    const CC_APPROVAL_STATUS = {
        CARD_HOLDER: 'card holder',
        DECLINED: 'declined',
        PRE_APPROVED: 'pre-approved',
        INSTANT_CREDIT: 'instant-credit',
        IN_PROGRESS_APP: 'in-progress-app',
        OTHER: 'other'
    };

    const DELIVERY_OPTIONS_MAP = {
        Standard: 'standard',
        Sameday: 'same day delivery',
        Pickup: 'buy online and pick up'
    };

    const MEDALLIA = {
        FEEDBACK: { LET_US_KNOW: 'medallia:feedback:let us know' },
        FORM: {
            DISPLAYED: 'medallia:form displayed',
            SUBMITTED: 'medallia:form submitted',
            DISMISSED: 'medallia:form dismissed'
        }
    };

    const ALT_PICKUP = {
        PAGE_NAME: 'bopis:alternate-pickup:n/a:*',
        ADD: 'alternate pickup person:request',
        EDIT: 'alternate pickup person:edit',
        REMOVE: 'alternate pickup person:removed',
        SAVE: 'alternate pickup person:submit'
    };

    const UGC_DYNAMIC_WIDGET = {
        IMAGE_CLICKED: 'ugc:image component click',
        SCROLL_MORE: 'ugc:scroll more navigation',
        SWIPE: 'ugc:product-swipe',
        SEE_DETAILS: 'ugc:see details',
        PAGE_NAME: 'modal:ugc modal:n/a:*'
    };

    const PRODUCT_AUTO_REPLENISH_ELIGIBLE = {
        AVAILABLE: 1,
        NOT_ALL_SKUS_AVAILABLE: 2,
        NOT_AVAILABLE: 3
    };

    const REPLACEMENT_ORDER = {
        PAGE_NAME: `${PAGE_TYPES.REPLACEMENT_ORDER}:submit for review:n/a:*`,
        SUBMIT_EVENT: `${PAGE_TYPES.REPLACEMENT_ORDER}:submit for review click`,
        SUBMIT_PAGE_ENTER: 'submit for review',
        SELECT_SAMPLES: 'select samples',
        SELECT_SAMPLES_ENTER: `${PAGE_TYPES.REPLACEMENT_ORDER}:select samples:n/a:*`,
        SPINNER_PAGE_ENTER: `${PAGE_TYPES.REPLACEMENT_ORDER}:fraud check processing:n/a:*`,
        SPINNER_PAGE: 'fraud check processing',
        FAILURE_PAGE_ENTER: 'request declined',
        SUCCESS_PAGE_ENTER: 'confirmation',
        EVENT_NAME: 'event260'
    };

    const SMS_SIGNUP = {
        PAGE_NAME: 'modal:sms-get order updates:n/a:*',
        CONFIRMATION_PAGE_NAME: 'modal:sms-confirmation:n/a:*'
    };
    const NO_PAGE_LOAD_PAGE_TYPES = [OrderDetails];

    return {
        ACTION_INFO,
        ADD_TO_BASKET_MODAL,
        ADD_TO_CART,
        ADD_TO_LOVES_LIST,
        ALT_PICKUP,
        ASYNC_PAGE_LOAD,
        CAMPAIGN_STRINGS,
        CAROUSEL_NAMES,
        CATEGORY_PAGE_LOAD,
        CC_APPROVAL_STATUS,
        COMPONENT_TITLE,
        CONTEXT,
        CUSTOMIZABLE_SETS_VARIANTS,
        DELIVERY_OPTIONS_MAP,
        DOUBLE_CLICK_CATEGORY_PAGE,
        DOUBLE_CLICK_FOOTER,
        DOUBLE_CLICK_PRODUCT_PAGE,
        Event,
        EVENT_NAMES,
        GET_MOST_RECENT_EVENT,
        LinkData,
        LINK_TRACKING_EVENT,
        SOT_LINK_TRACKING_EVENT,
        MEDALLIA,
        MEDIA_TYPE,
        PAGE_DETAIL,
        PAGE_LOAD,
        PAGE_NAMES,
        PAGE_TYPES,
        PAGE_VARIANTS,
        PINTEREST_PRODUCT_PAGE_VIEW_EVENT,
        PINTEREST_QUICK_LOAD_EVENT,
        PRODUCT_AUTO_REPLENISH_ELIGIBLE,
        PRODUCT_PAGE_LOAD,
        PRODUCT_TAGGING_PLATFORMS,
        QUICK_LOOK_LOAD,
        REFERRER_DOMAINS,
        REGISTER_MODAL_LOAD,
        REPLACEMENT_ORDER,
        SDU_STATUS,
        SIGN_IN_MODAL_LOAD,
        SIGN_IN_PAGE_TYPE_DETAIL,
        SIGN_IN_PAGE_TYPE_GUEST_CHECKOUT_DETAIL,
        SIGN_IN_SUCCESS,
        SNAPCHAT_PRODUCT_PAGE_VIEW_EVENT,
        SNAPCHAT_QUICK_LOAD_EVENT,
        UGC_DYNAMIC_WIDGET,
        NO_PAGE_LOAD_PAGE_TYPES,
        SMS_SIGNUP,
        SDU_SUBSCRIPTION_TYPE
    };
}());
